<app-navbar></app-navbar>

<div class="marginLateral">
    <router-outlet>

    </router-outlet>
</div>

<app-footer></app-footer>